import { createSlice } from "@reduxjs/toolkit";
import { reset } from "../actions";

const initialState = {
  page: 0,
  data: {
    orderNumber: "",
    orderDate: "",
    orderAmount: 0,
	orderAmountWithDiscount: 0,
    orderForm: 35,
    orderStatus: 1,
	serviceOption: "",
    sampleAmount: "",
    dropBoxId: null,
    dropBoxDate: "",
    comments: "",
    tableData: [],
	discountId: null
  },
  billingInformation: {
    firstName: "",
    lastName: "",
    company: "",
    phone: "",
    email: "",
    shippingOption: "Dropbox",
    dropboxLocation: "",
    dropoffDate: "",
    billingMethod: "",
    purchasingAgentName: "",
    purchasingAgentEmail: "",
    poNumber: "",
    grantNumber:"",
    grantPi:"",
    grantNote:"",
    ccNumber: "",
    ccMonth: "",
    ccYear: "",
    cvv: "",
    ccZip: "",
    cardType: "",
    ccName: "",
    acgtCard: "",
  },
  primer: {
    primerList: [],
    primerAmount: "",
    banking: null,
    primerSynthesisList: [],
    synthesis: null,
  },
};

const wpsFormSlice = createSlice({
  name: "wpsorderform",
  initialState,
  reducers: {
    //action creators
    initializeWpsTableData(state, action) {
      for (let i = 0; i < action.payload; i++) {
        const newObj = {
          id: i + 1,
          sampleID: "",
          sampleConc: "",
          sampleType: "",
          targetSize: '',
          dataAnalysis: "",
          orderId: 0,
        };
        state.data.tableData.push(newObj);
      }
      return;
    },
    resetWpsState(state, action) {
      Object.assign(state, initialState);
      return;
    },
    resetWpsTableData(state, action) {
      state.data.tableData = action.payload;
      return;
    },
    setWpsSampleAmount(state, action) {
      state.data.sampleAmount = parseInt(action.payload);
      return;
    },
    addWpsRow(state, action) {
      const newRow = action.payload;
      // Add the new row to the end of tableData
      state.data.tableData.push(newRow);

      // Reset the indices in the updated tableData
      state.data.tableData = state.data.tableData.map((item, index) => ({
        ...item,
        id: index + 1,
      }));
      state.data.sampleAmount = parseInt(state.data.sampleAmount + 1);
      return;
    },
    editWpsRow(state, action) {
      const { index, value, property } = action.payload;
		let pattern = /^[a-zA-Z0-9-_]{0,30}$/;
      const updatedData = [...state.data.tableData];

      if (property === "sampleID") {
        if (pattern.test(value)) {
          updatedData[index][property] = value;
        } else {
          // You may want to handle this case differently, e.g., show an error message
          alert(
			"Only special characters allowed: hyphen( - ) and underscore( _ ).\nMax character length = 30."
          );
          return;
        }
      } else {
        updatedData[index][property] = value;
      }

      // Assuming your state has a property named "tableData"
      state.data.tableData = updatedData;
    },
    copyWpsRow(state, action) {
      const { index } = action.payload;
      const rowToCopy = state.data.tableData[index];

      // Create a copy of the row with a new id
      const copiedRow = {
        ...rowToCopy,
        id: state.data.tableData.length + 1, // Assign a new id or adjust as needed
      };

      // Insert the copied row at a specific position (e.g., next to the original row)
      state.data.tableData.splice(index + 1, 0, copiedRow);

      // Reset the indices in the updated tableData
      state.data.tableData = state.data.tableData.map((item, i) => ({
        ...item,
        id: i + 1,
      }));
      state.data.sampleAmount = parseInt(state.data.sampleAmount + 1);
      return;
    },
    deleteWpsRow(state, action) {
      const { index } = action.payload;
      const updatedTableData = state.data.tableData.filter(
        (item, i) => i !== index
      );

      // Reset the indices in the updated tableData
      const resetIndexedTableData = updatedTableData.map((item, i) => ({
        ...item,
        id: i + 1,
      }));

      // Update the tableData state
      state.data.tableData = resetIndexedTableData;
      state.data.sampleAmount = parseInt(state.data.sampleAmount - 1);
      return;
    },
    toggleWpsCheckbox(state, action) {
      const { index, property } = action.payload;
      const newData = [...state.data.tableData];
      newData[index][property] = !newData[index][property];
      state.data.tableData = newData;
    },
    increaseWpsConcentration(state, action) {
      const { index, property } = action.payload;
      if(state.data.tableData[index][property] === ''){
        state.data.tableData[index][property] = 0
      }
      state.data.tableData[index][property] = parseInt(state.data.tableData[index][property]) + 1;
    },
    decreaseWpsConcentration(state, action) {
      const { index, property } = action.payload;
      if (state.data.tableData[index][property] > 0) {
        state.data.tableData[index][property] -= 1;
      }
    },
    clearWpsSelect(state, action) {
      const { index, property } = action.payload;

      state.data.tableData[index] = {
        ...state.data.tableData[index],
        [property]: "", // Set the specified property to an empty string for the specific row
      };

      return;
    },
    wpsPrevStep: (state, action) => {
      state.page = state.page - 1;
    },
    wpsNextStep: (state, action) => {
      state.page = state.page + 1;
    },
    wpsSetStep: (state, action) => {
      state.page = action.payload;
    },
    resetWpsPage: (state, action) => {
      state.page = action.payload;
    },
    initializeWpsPrimerTableData(state, action) {
      for (let i = 0; i < action.payload; i++) {
        const newObj = {
          id: i + 1,
          pName: "",
          pSequence: "",
        };
        state.primer.primerSynthesisList.push(newObj);
      }
      return;
    },
    setWpsPrimerAmount(state, action) {
      state.primer.primerAmount = parseInt(action.payload);
      return;
    },
    addWpsPrimerRow: (state, action) => {
      const newRow = action.payload;
      // Add the new row to the end of tableData
      state.primer.primerSynthesisList.push(newRow);

      // Reset the indices in the updated tableData
      state.primer.primerSynthesisList = state.primer.primerSynthesisList.map(
        (item, index) => ({
          ...item,
          id: index + 1,
        })
      );
      state.primer.primerAmount = parseInt(state.primer.primerAmount + 1);
      return;
    },
    editWpsPrimerRow(state, action) {
      const { index, property, value } = action.payload;
      let pattern = /^[a-zA-Z0-9_-]*$/;
      const updatedData = [...state.primer.primerSynthesisList];

      if (property === "pSequence" || property === "pName") {
        if (pattern.test(value)) {
          updatedData[index][property] = value;
        } else {
          return;
        }
      } else {
        updatedData[index][property] = value;
      }

      // Assuming your state has a property named "tableData"
      state.primer.primerSynthesisList = updatedData;
    },
    deleteAllWpsPrimer(state, action) {
      state.primer.primerSynthesisList = action.payload;
      state.primer.primerAmount = "";
      return;
    },
    setWpsPrimerBanking(state, action) {
      state.primer.banking = action.payload;
      return;
    },
    setWpsPrimerList(state, action) {
      const list = action.payload.split(/,\s|\n|,/);
      state.primer.primerList = list;
      // console.log(state.primer.primerList);
      return;
    },
    setWpsPrimerSynthesis(state, action) {
      state.primer.synthesis = action.payload;
      return;
    },
    setWpsComments(state, action) {
      state.data.comments = action.payload;
      return;
    },
    setWpsDropboxLocation(state, action) {
      state.billingInformation.dropboxLocation = action.payload.label;
      return;
    },
    setWpsDropboxId(state, action) {
      state.data.dropBoxId = action.payload
      return;
    },
    setWpsDropoffDate(state, action) {
      state.billingInformation.dropoffDate = action.payload;
      state.data.dropBoxDate = action.payload;
      // Test the regular expression with a date
      // if (dateRegex.test(result)) {
      // }
    },
    setWpsFirstName(state, action) {
      state.billingInformation.firstName = action.payload;
      return;
    },
    setWpsLastName(state, action) {
      state.billingInformation.lastName = action.payload;
      return;
    },
    setWpsCompany(state, action) {
      state.billingInformation.company = action.payload;
    },
    setWpsPhone(state, action) {
      const phoneRegex = /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/;
      const result = action.payload;

      // Test the regular expression with a date
      // if (phoneRegex.test(result)) {
      //   state.billingInformation.phone = result;
      // }
      state.billingInformation.phone = result;
    },
    setWpsEmail(state, action) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      state.billingInformation.email = action.payload;
    },
    setWpsShippingOption(state, action) {
      state.billingInformation.shippingOption = action.payload;
      return;
    },
    setWpsAcgtCard(state, action) {
      state.billingInformation.acgtCard = action.payload;
      return;
    },
    setWpsCCNumber(state, action) {
      state.billingInformation.ccNumber = action.payload;
      return;
    },
    setWpsCCMonth(state, action) {
      state.billingInformation.ccMonth = action.payload;
      return;
    },
    setWpsCCYear(state, action) {
      state.billingInformation.ccYear = action.payload;
      return;
    },
    setWpsCVV(state, action) {
      state.billingInformation.cvv = action.payload;
      return;
    },
    setWpsCCZip(state, action) {
      state.billingInformation.ccZip = action.payload;
      return;
    },
    setWpsCCName(state, action) {
      state.billingInformation.ccName = action.payload;
      return;
    },
    setWpsCardType(state, action) {
      state.billingInformation.cardType = action.payload;
      return;
    },
    setWpsBillingMethod(state, action) {
      state.billingInformation.billingMethod = action.payload;
      return;
    },
    setWpsPurchasingAgentName(state, action) {
      state.billingInformation.purchasingAgentName = action.payload;
      return;
    },
    setWpsPurchasingAgentEmail(state, action) {
      state.billingInformation.purchasingAgentEmail = action.payload;
      return;
    },
    setWpsPoNumber(state, action) {
      state.billingInformation.poNumber = action.payload;
      return;
    },
    setWpsOrderNumber(state, action) {
      state.data.orderNumber = action.payload;
      return;
    },
    setWpsOrderAmount(state, action) {
      state.data.orderAmount = action.payload;
      return;
    },
	setWpsOrderAmountWithDiscount(state, action) {
      state.data.orderAmountWithDiscount = action.payload;
      return;
    },
    setWpsOrderDiscount(state, action) {
      state.data.discountId = action.payload
    },
    setWpsGrantNumber(state, action) {
      state.billingInformation.grantNumber = action.payload;
      return;
    },
    setWpsGrantPI(state, action) {
      state.billingInformation.grantPi = action.payload;
      return;
    },
    setWpsGrantNote(state, action) {
      state.billingInformation.grantNote = action.payload;
      return;
	},
	setWpsServiceOption(state, action) {
		state.data.serviceOption = action.payload;
		return;
	},
	clearWpsServiceOption(state, action) {
		state.data.serviceOption = action.payload;
		return;
	},
  },
  //tell our combined reducer to look for additional action types
  extraReducers(builder) {
    builder.addCase(reset, (state, action) => {
      return {};
    });
  },
});

export const {
  initializeWpsTableData,
  resetWpsState,
  resetWpsTableData,
  setWpsSampleAmount,
  addWpsRow,
  editWpsRow,
  copyWpsRow,
  deleteWpsRow,
  toggleWpsCheckbox,
  increaseWpsConcentration,
  decreaseWpsConcentration,
  clearWpsSelect,
  wpsNextStep,
  wpsPrevStep,
  wpsSetStep,
  resetWpsPage,
  initializeWpsPrimerTableData,
  setWpsPrimerAmount,
  addWpsPrimerRow,
  editWpsPrimerRow,
  deleteAllWpsPrimer,
  setWpsPrimerBanking,
  setWpsPrimerList,
  setWpsPrimerSynthesis,
  setWpsComments,
  setWpsDropoffDate,
  setWpsDropboxLocation,
  setWpsDropboxId,
  setWpsFirstName,
  setWpsLastName,
  setWpsCompany,
  setWpsPhone,
  setWpsEmail,
  setWpsShippingOption,
  setWpsAcgtCard,
  setWpsCCNumber,
  setWpsCCMonth,
  setWpsCCYear,
  setWpsCVV,
  setWpsCCZip,
  setWpsCCName,
  setWpsCardType,
  setWpsPurchasingAgentName,
  setWpsPurchasingAgentEmail,
  setWpsPoNumber,
  setWpsOrderNumber,
  setWpsOrderAmount,
  setWpsOrderAmountWithDiscount,
  setWpsOrderDiscount,
  setWpsGrantNumber,
  setWpsGrantPI,
  setWpsGrantNote,
	setWpsBillingMethod,
	setWpsServiceOption,
	clearWpsServiceOption,
} = wpsFormSlice.actions;
export const wpsFormReducer = wpsFormSlice.reducer;
